import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ApolloError } from '@apollo/client';
import { getMessageParamsFromError } from '~/content/server-errors';
import { Queries, Types } from '~/graphql';
import { useDownloadFile } from './useDownloadFile';
import { useAlert } from '~/shared/contexts';

export const useDownloadProgram = (contentId: Types.UUID) => {
    const { openAlert } = useAlert();
    const { formatMessage, locale } = useIntl();
    const downloadFile = useDownloadFile();
    const [isDownloading, setIsDownloading] = useState(false);

    const [fetchProgramFile] = Queries.useGetContentProgramLazyQuery();

    const downloadContentProgram = async () => {
        setIsDownloading(true);
        try {
            const contentProgramResponse = await fetchProgramFile({
                variables: {
                    contentId
                }
            });
            const downloadUrl = contentProgramResponse.data?.contentProgram?.file?.downloadUrl;
            const downloadName = formatMessage({ id: 'catalog.product.details.program.title' });
            downloadUrl &&
                (await downloadFile(downloadUrl, downloadName, setIsDownloading, {
                    credentials: 'omit'
                }));
        } catch (error) {
            openAlert({
                variant: 'error',
                ...getMessageParamsFromError(error as ApolloError, locale)
            });
        } finally {
            setIsDownloading(false);
        }
    };

    return {
        downloadContentProgram,
        isDownloading
    };
};
